import { animate } from 'popmotion';
import { gsap } from 'gsap/all';

const defaults = {
    mass: 1,
    damping: 10,
    stiffness: 100,
    onComplete: () => {},
};

// Usage Example:
// spring(circle, {
//     from: 1,
//     to: 0.89,
//     attribute: 'scale',
//     tension: 800,
//     friction: 10,
//     onComplete: () => {
//         console.log('Complete');
//     },
// });

const spring = (element, params) => {
    animate({
        from: params.from,
        to: params.to,
        type: 'spring',
        mass: params.mass || defaults.mass,
        stiffness: params.tension || defaults.stiffness,
        damping: params.friction || defaults.damping,
        onUpdate: (latest) => {
            gsap.set(element, {
                [params.attribute]: latest,
            });
        },
        restDelta: 0.001,
        restSpeed: 0.001,
        onComplete: params.onComplete || defaults.onComplete,
    });
};

export default spring;
